import { devices } from '@src/styles/theme';
import React from 'react';
import styled from 'styled-components';

/**
 * 헌혈의집 목록 상단 (디자인 시스템 적용 — 헌혈요청/커뮤니티 목록과 같은 구성).
 * 타이틀 + 총 개수 → 검색 + 혈액원 필터 칩
 */
export const BANK_TABS = [
  { value: '', label: '전체' },
  { value: 'RED_CROSS', label: '대한적십자사' },
  { value: 'HANMAUM', label: '한마음혈액원' },
];

type Props = {
  totalCount?: number;
  keyword: string;
  onKeywordChange: (v: string) => void;
  onSearch: () => void;
  activeBank: string;
  onBankChange: (v: string) => void;
};

const BloodHomeListHeader = ({
  totalCount,
  keyword,
  onKeywordChange,
  onSearch,
  activeBank,
  onBankChange,
}: Props) => (
  <Wrap>
    <TitleRow>
      <Title>헌혈의 집</Title>
      {totalCount != null && (
        <SubText>
          가까운 헌혈센터 <b>{totalCount}곳</b>
        </SubText>
      )}
    </TitleRow>

    <FilterRow>
      <Tabs>
        {BANK_TABS.map((tab) => (
          <Tab
            key={tab.label}
            active={activeBank === tab.value}
            onClick={() => onBankChange(tab.value)}
          >
            {tab.label}
          </Tab>
        ))}
      </Tabs>
      <SearchBox>
        <SearchIcon />
        <SearchInput
          value={keyword}
          placeholder="헌혈의 집 이름 · 지역으로 검색"
          onChange={(e) => onKeywordChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSearch();
          }}
        />
      </SearchBox>
    </FilterRow>
  </Wrap>
);

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const TitleRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
`;
const Title = styled.h1`
  margin: 0;
  font-family: 'Var', sans-serif;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.6px;
  color: #222222;
  @media ${devices.tablet} {
    font-size: 24px;
  }
`;
const SubText = styled.span`
  font-size: 14px;
  color: #767676;
  padding-bottom: 5px;
  b {
    color: #ff4651;
  }
`;
const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;
const Tabs = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;
const Tab = styled.button<{ active: boolean }>`
  height: 38px;
  padding: 0 16px;
  border-radius: 19px;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  border: 1px solid ${({ active }) => (active ? '#FF4651' : '#E6E6E6')};
  background: ${({ active }) => (active ? '#FFF1ED' : '#ffffff')};
  color: ${({ active }) => (active ? '#FF4651' : '#767676')};
`;
const SearchBox = styled.div`
  margin-left: auto;
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 19px;
  padding: 0 14px;
  height: 38px;
  width: 240px;
  @media ${devices.tablet} {
    margin-left: 0;
    width: 100%;
  }
`;
const SearchIcon = styled.span`
  flex: none;
  width: 14px;
  height: 14px;
  border: 1.6px solid #9a9a9a;
  border-radius: 50%;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    right: -4px;
    bottom: -4px;
    width: 6px;
    height: 1.6px;
    background: #9a9a9a;
    transform: rotate(45deg);
  }
`;
const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Regular', sans-serif;
  font-size: 13.5px;
  color: #222222;
  width: 100%;
`;

export default BloodHomeListHeader;
